import sscache from 'session-storage-cache';

export const logoutOnAmazon = () => {
  window.amazon?.Login.logout();
  sscache.remove('amazonAccessToken');
};
